import { Button, Dialog, DialogActions, DialogContent, Divider, Grid, Typography, Skeleton, Paper, Box, Chip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import DialogTitle from '@mui/material/DialogTitle';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import axiosInstance from 'custom-axios';
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
// import ArrowForwardAltRoundedIcon from "@mui/icons-material/ArrowForwardAltRounded";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

const ClientChangeActivityLogModal = (props) => {


    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [changeLog, setChangeLog] = useState([])

    const fetchManagerChangeLog = async () => {

        try {
            showLoader()
            const response = await axiosInstance.get(`api/on-boarding-activity-details/${props.id}`);

            if (response.success) {
                setChangeLog(response.data);
                toast.success(response.message)
            }

        } catch (error) {
            toast.error(error.message)
        } finally {
            hideLoader();
        }
    }

    useEffect(() => {
        if (props.open && props.id !== null) {
            fetchManagerChangeLog()
        }
    }, [props.open, props.id])

    return (
        <>

            <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title" fullWidth maxWidth="md">
                <DialogTitle id="form-dialog-title" className='font15px'>Change Log</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ outline: 'none', padding: '16px 0px 0px 16px' }}>

                        <Grid item xs={12} className="change-log-header">
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography variant="h6"><strong>Title</strong></Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="h6"><strong>Then</strong></Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="h6"><strong>Now</strong></Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {changeLog.length > 0 ? (
                            changeLog.map((item, index) => (
                                <Grid item xs={12} key={index} className={`change-log-item ${item.is_modified ? 'highlighted' : ''}`}>
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <Typography className='text-dark'><strong>{item.label}</strong></Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography>{item.old_value}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography>{item.new_value}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))
                        ) : (
                            <Grid item xs={12}>
                                <Typography>No changes found.</Typography>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={props.handleClose} color="primary" className='font15px'>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            {loader}
            <ToastContainer />
        </>
    )
}

export default ClientChangeActivityLogModal;